<template lang='pug' src='./Footer.pug'></template>

<script>
import Icon from 'components/icon/icon'

export default {
  props: ['props'],
  computed: {
    classObject () {
      return {
        home: this.$route.name === 'home',
        aboutus: this.$route.name === 'about us'
      }
    }
  },
  components: {
    Icon
  }
}
</script>



// WEBPACK FOOTER //
// Footer.vue?26b6c3c8